import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=2df5de92&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Logout.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Logout.vue
// module id = 2318
// module chunks = 1